import React, { memo } from 'react';
import { ControlModel } from '../../../types/control';
import { Column } from '../../Column';
import { Widget } from '../../Widget';
import './index.scss';
import minusIcon from '../../../assets/images/icons/controls/minus.png';
import plusIcon from '../../../assets/images/icons/controls/plus.png';
import { onClickHandler } from '../../../utils/onclick';

type Props = {
    icon: string;
    control: ControlModel;
    setWindSpeed: string;
    currentWindSpeed: string;
    click: () => void;
    windSpeedChangeClick: (isPlus: boolean) => void;
};

export const WindControlComponent = memo(function WindControlComponent({ icon, control, currentWindSpeed, setWindSpeed, click, windSpeedChangeClick }: Props) {
    return (
        <Column min={6} max={12}>
            <Widget style={{ padding: 0 }}>
                <div className="windspeed-wrapper">
                    <img {...onClickHandler(click)} src={icon} alt='img' />
                    <span>{control.name}</span>
                    <div className="windspeed-content">
                        <span className="set-value-windspeed">
                            {currentWindSpeed}<small>M/S</small>
                        </span>
                        <span className="home-value-windspeed">
                            {setWindSpeed}<small>M/S</small>
                        </span>
                    </div>
                    <div className="control-button-wrapper">
                        <div className="control-button">
                            <button {...onClickHandler(() => windSpeedChangeClick(false))}>
                                <img src={minusIcon} alt='minus' />
                            </button>
                        </div>
                        <div className="control-button">
                            <button {...onClickHandler(() => windSpeedChangeClick(true))}>
                                <img src={plusIcon} alt='plus' />
                            </button>
                        </div>
                    </div>
                </div>
            </Widget>
        </Column>
    );
});
